import { graphql, useFragment } from 'react-relay';

import { isMultiItemCheckoutVariant } from 'dibs-checkout/exports/useMultiItemCheckoutTracking.ts';

import { type useShowPdpSharedShoppingButtons_viewer$key } from './__generated__/useShowPdpSharedShoppingButtons_viewer.graphql.ts';

// regionalInfo with no userId, zip, or country resolves from the request IP,
// not a saved shipping address or region-selector override.
const viewerFragment = graphql`
    fragment useShowPdpSharedShoppingButtons_viewer on Viewer {
        restrictAddToCartOutsideUs: featureFlag(feature: "restrictAddToCartOutsideUs")
        ipRegionalInfo: regionalInfo {
            countryCode
        }
    }
`;

export const shouldShowPdpSharedShoppingButtons = ({
    isMultiItemCart,
    restrictAddToCartOutsideUs,
    ipCountryCode,
}: {
    isMultiItemCart: boolean;
    restrictAddToCartOutsideUs: boolean;
    ipCountryCode: string | null | undefined;
}): boolean => {
    if (!isMultiItemCart) {
        return false;
    }
    if (!restrictAddToCartOutsideUs) {
        return true;
    }
    return ipCountryCode === 'US';
};

export const useShowPdpSharedShoppingButtons = (
    viewerRef: useShowPdpSharedShoppingButtons_viewer$key | null | undefined
): boolean => {
    const viewer = useFragment(viewerFragment, viewerRef);

    return shouldShowPdpSharedShoppingButtons({
        isMultiItemCart: isMultiItemCheckoutVariant(),
        restrictAddToCartOutsideUs: !!viewer?.restrictAddToCartOutsideUs,
        ipCountryCode: viewer?.ipRegionalInfo?.[0]?.countryCode,
    });
};
